import React, { useRef, useState } from 'react';
import {
    Button,
    ButtonGroup,
    IconButton,
    Menu,
    MenuItem,
    Popover,
    Box,
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { LocalizationProvider, StaticDateTimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import CloseIcon from "@mui/icons-material/Close";
import { getCurrentESTDatePlus10Min } from '../../utils/dateHelper';
import SendIcon from "@mui/icons-material/Send";
interface Props {
    onSend: () => void;
    onScheduleSend: (dateTime: Date) => void;
}

const SendWithScheduleButton: React.FC<Props> = ({ onSend, onScheduleSend }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [pickerAnchorEl, setPickerAnchorEl] = useState<null | HTMLElement>(null);
    const currentEstTimePlus10Min = getCurrentESTDatePlus10Min();
    const [selectedDateTime, setSelectedDateTime] = useState<Date | null>(currentEstTimePlus10Min);
    const sendButtonRef = useRef(null);

    const handleClick = () => {
        setAnchorEl(sendButtonRef.current);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleScheduleClick = () => {
        setPickerAnchorEl(anchorEl);
        setAnchorEl(null);
    };

    const handleConfirmSchedule = () => {
        if (selectedDateTime) {
            onScheduleSend(selectedDateTime);
            setPickerAnchorEl(null);
        }
    };

    return (
        <>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <ButtonGroup variant="contained" size="small" >
                    <Button
                        id="send"
                        ref={sendButtonRef}
                        onClick={onSend}
                        startIcon={<SendIcon />}
                        className="send-button"
                    >
                        <span className="send-text">Send</span>
                    </Button>
                    <IconButton
                        onClick={handleClick}
                        size="small"
                    >
                        <ArrowDropDownIcon />
                    </IconButton>
                </ButtonGroup>

                <Menu
                    MenuListProps={{ dense: true }}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }} anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
                    <MenuItem id="menuScheduleSend" onClick={handleScheduleClick}>Schedule Send</MenuItem>
                </Menu>

                <Popover
                    open={Boolean(pickerAnchorEl)}
                    anchorEl={pickerAnchorEl}
                    onClose={() => setPickerAnchorEl(null)}
                    anchorReference="anchorPosition"
                    anchorPosition={{ top: window.innerHeight / 2 - 250, left: window.innerWidth / 3 }}
                >
                    <Box className="date-time-picker-wrap">
                        <IconButton
                            size="small"
                            onClick={() => setPickerAnchorEl(null)}
                            sx={{ position: 'absolute', top: -0, right: 4 }}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <StaticDateTimePicker
                            orientation="landscape"
                            value={selectedDateTime}
                            disablePast
                            onChange={(newValue) => setSelectedDateTime(newValue)}
                            slots={{ actionBar: () => null }}
                            slotProps={{
                                toolbar: {
                                    className: "msg-datetime-toolbar",
                                    sx: {
                                        display: { xs: 'none', md: 'flex' }
                                    }
                                },
                            }}
                        />
                        <Box display="flex" justifyContent="flex-end" mt={2}>
                            <Button onClick={() => setPickerAnchorEl(null)} size="small">
                                Cancel
                            </Button>
                            <Button id="scheduleSend" onClick={handleConfirmSchedule} size="small" variant="contained">
                                Schedule Send
                            </Button>
                        </Box>
                    </Box>
                </Popover>
            </LocalizationProvider>
        </>
    );
};

export default SendWithScheduleButton;
